import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FieldItem from './FieldItem';
import EditAddressModal from '../../components/EditAddressModal';

interface AddressSectionProps {
  isEditing: boolean;
  profileData: any;
  onAddressChange: (address: { street: string; city: string; state: string; zipCode: string; country?: string }) => void | Promise<void>;
}

const AddressSection: React.FC<AddressSectionProps> = ({ isEditing, profileData, onAddressChange }) => {
  const [showEditAddressModal, setShowEditAddressModal] = useState(false);

  const handleOpen = () => {
    if (!isEditing) return;
    setShowEditAddressModal(true);
  };

  const handleSave = async (address: any) => {
    await Promise.resolve(onAddressChange(address));
    setShowEditAddressModal(false);
  };

  return (
    <View style={localStyles.sectionCard}>
      <Text style={localStyles.sectionTitle}>Address</Text>
      <Text style={localStyles.sectionHint}>Used for camp discovery and host listings where applicable.</Text>
      <View style={localStyles.infoGrid}>
        <FieldItem
          label="Address"
          iconName="home"
          isEditing={isEditing}
          onPress={handleOpen}
          containerStyle={localStyles.fullWidth}
        >
          <View style={localStyles.fieldContent}>
            <View style={localStyles.addressDisplay}>
              <View style={localStyles.addressLine}>
                <Text style={localStyles.addressLabel}>Street:</Text>
                <Text style={localStyles.displayText}>{profileData.street || 'Not provided'}</Text>
              </View>
              <View style={localStyles.addressLine}>
                <Text style={localStyles.addressLabel}>City:</Text>
                <Text style={localStyles.displayText}>{profileData.city || 'Not provided'}</Text>
              </View>
              <View style={localStyles.addressLine}>
                <Text style={localStyles.addressLabel}>State:</Text>
                <Text style={localStyles.displayText}>{profileData.state || 'Not provided'}</Text>
              </View>
              <View style={localStyles.addressLine}>
                <Text style={localStyles.addressLabel}>ZIP:</Text>
                <Text style={localStyles.displayText}>{profileData.zipCode || 'Not provided'}</Text>
              </View>
              {!!profileData.country && (
                <View style={localStyles.addressLine}>
                  <Text style={localStyles.addressLabel}>Country:</Text>
                  <Text style={localStyles.displayText}>{profileData.country}</Text>
                </View>
              )}
            </View>
          </View>
        </FieldItem>
      </View>

      {showEditAddressModal && (
        <EditAddressModal
          visible={showEditAddressModal}
          onClose={() => setShowEditAddressModal(false)}
          onSave={handleSave}
          currentAddress={{
            street: profileData.street || '',
            city: profileData.city || '',
            state: profileData.state || '',
            zipCode: profileData.zipCode || '',
            country: profileData.country || '',
          }}
        />
      )}
    </View>
  );
};

export default AddressSection;

const localStyles = StyleSheet.create({
  sectionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    padding: 24,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: '#F1F5F9',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.03,
    shadowRadius: 10,
    elevation: 3,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: '800',
    color: '#1E293B',
    marginBottom: 8,
    letterSpacing: -0.5,
  },
  sectionHint: {
    fontSize: 14,
    color: '#64748B',
    marginBottom: 20,
    lineHeight: 20,
  },
  infoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  fullWidth: {
    width: '100%',
  },
  fieldContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  addressDisplay: {
    flex: 1,
  },
  addressLine: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
    gap: 12,
  },
  addressLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: '#94A3B8',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    minWidth: 70,
  },
  displayText: {
    fontSize: 15,
    fontWeight: '500',
    color: '#1E293B',
    paddingVertical: 4,
  },
});


